/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Private_DescInputs */



/**
* | output |
* | --- |
* | "hidden until the finals start" |
*
* @param {Og_Cfg_Private_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_private_desc = /** @type {((inputs?: Og_Cfg_Private_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Private_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("masqué jusqu'au début de la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("oculta hasta que empiecen las finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("oculta até o início das finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("nascosta finché non iniziano le finali")
	return /** @type {LocalizedString} */ ("hidden until the finals start")
});